import { MODULES } from '@/configuration/role/roleManagerConf';
import { cloneDeep } from 'lodash';

export default function transfertCategoriePermission(
  tableauAllPermissions,
  tableauCategorieToTranfert,
) {
  tableauCategorieToTranfert.forEach((el) => {
    const moduleCibleFind = tableauAllPermissions.find((module) => module.name === el.moduleCible);
    if (!moduleCibleFind) return;
    const indexModuleParam = tableauAllPermissions.findIndex((module) => module.name === 'parametrage');
    const categorieCibleFind = moduleCibleFind.categorie.find(
      (element) => element.name === el.categorieCible,
    );
    if (!categorieCibleFind) return;
    const indexOfCategorieCible = moduleCibleFind.categorie.findIndex(
      (element) => element.name === el.categorieCible,
    );
    let moduleDestinationFind = {};
    const checkIfModuleIsInArray = tableauAllPermissions.find(
      (module) => module.name === el.moduleDestination);
    if (checkIfModuleIsInArray) {
      moduleDestinationFind = checkIfModuleIsInArray;
    } else {
      const moduleConfigFind = MODULES.find((module) => module.name === el.moduleDestination);
      if (!moduleConfigFind) return;
      moduleDestinationFind = cloneDeep(moduleConfigFind);
      tableauAllPermissions.splice(indexModuleParam, 0, moduleDestinationFind);
    }
    const categorieAlreadyExist = moduleDestinationFind.categorie.find(
      (cat) => cat.name === categorieCibleFind.name,
    );
    if (categorieAlreadyExist) return;
    moduleDestinationFind.categorie.push(categorieCibleFind);
    moduleCibleFind.categorie.splice(indexOfCategorieCible, 1);
  });
}
